module.exports = __webpack_public_path__ + "img/alipay_0.fc6f8a57.png";